import {
  Tabs,
  Table,
  Form,
  Input,
  Button,
  Space,
  Popconfirm,
  message,
  Modal
} from "antd";
import { useEffect, useState } from "react";
import axios from "axios";
import { Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";

export default function Document() {
  const [activeTab, setActiveTab] = useState("1");
  const [documents, setDocuments] = useState<any[]>([]);
  const [selected, setSelected] = useState<any>(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [files1, setFiles1] = useState<any[]>([]);
  const [files2, setFiles2] = useState<any[]>([]);
  const [files3, setFiles3] = useState<any[]>([]);
  const [files4, setFiles4] = useState<any[]>([]);
  const [files5, setFiles5] = useState<any[]>([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string>("");
  const [previewType, setPreviewType] = useState<"image" | "pdf">("image");
  const [form] = Form.useForm();

  // 🔄 Charger documents
  const load = async () => {
    setLoading(true);
    const res = await axios.get("/api/documents", {
      params: { search }
    });
    setDocuments(res.data);
    setLoading(false);
  };

  useEffect(() => { load(); }, [search]);

  // ✏️ Ajouter / Modifier
  const onFinish = async (values: any) => {
    const uploadedFiles = files1
    .filter(f => f.status === "done")
    .map(f => f.response?.filePath);

  const payload = {
    ...values,
    pieceJointe1: uploadedFiles[0] || null,
    pieceJointe2: uploadedFiles[1] || null,
    pieceJointe3: uploadedFiles[2] || null,
    pieceJointe4: uploadedFiles[3] || null,
    pieceJointe5: uploadedFiles[4] || null,
  };

    if (selected)
      await axios.put(`/api/documents/${selected.idDoc}`, values);
    else
      await axios.post("/api/documents", values);

    message.success("Opération réussie");
    setFiles1([]);
    form.resetFields();
    setSelected(null);
    setActiveTab("1");
    load();
  };

  const handlePreview = async (file: any) => {
  const url = file.url || file.response?.filePath;

  if (!url) return;

  const isPdf = url.toLowerCase().endsWith(".pdf");

  setPreviewType(isPdf ? "pdf" : "image");
  setPreviewUrl(url);
  setPreviewVisible(true);
};
  // 🗑️ Supprimer
  const remove = async (id: number) => {
    await axios.delete(`/api/documents/${id}`);
    message.success("Document supprimé");
    load();
  };

  // 📋 Colonnes table
  const columns = [
    { title: "Client", dataIndex: "numcli" },
    { title: "Num Doc", dataIndex: "numDoc" },
    { title: "Ref Doc", dataIndex: "refDoc" },
    {
      title: "Actions",
      render: (_: any, record: any) => (
        <Space>
          <Button
            onClick={() => {
                        setFiles1(
                        [
                            selected.pieceJointe1,
                            selected.pieceJointe2,
                            selected.pieceJointe3,
                            selected.pieceJointe4,
                            selected.pieceJointe5
                        ]
                        .filter(Boolean)
                        .map((url: string, i: number) => ({
                            uid: String(i),
                            name: url.split("/").pop(),
                            status: "done",
                            url
                        }))
                        );

              setSelected(record);
              form.setFieldsValue(record);
              setActiveTab("2");
            }}
          >
            Modifier
          </Button>

          <Popconfirm
            title="Supprimer ce document ?"
            onConfirm={() => remove(record.idDoc)}
          >
            <Button danger>Supprimer</Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <>
      {/* Actions */}
      <Space style={{ marginBottom: 16,marginTop:35 }}>
        <Button
          type="primary"
          onClick={() => {
            setSelected(null);
            form.resetFields();
            setActiveTab("2");
          }}
        >
          Ajouter
        </Button>

        <Button onClick={() => setActiveTab("1")}>
          Consulter
        </Button>

        <Input.Search
          placeholder="Recherche..."
          onSearch={setSearch}
          allowClear
        />
      </Space>

      {/* Onglets */}
      <Tabs activeKey={activeTab} onChange={setActiveTab}>
        <Tabs.TabPane tab="Liste des documents" key="1">
          <Table
            rowKey="idDoc"
            loading={loading}
            columns={columns}
            dataSource={documents}
          />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Fiche document" key="2">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
          >
            <Form.Item
              name="numcli"
              label="Numéro Client"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="numDoc"
              label="Numéro Document"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="refDoc"
              label="Référence Document"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="description"
              label="Description"
            >
              <Input.TextArea />
            </Form.Item>

            <Form.Item label="Pièces jointes 1">
            <Upload
                multiple
                maxCount={5}
                fileList={files1}
                action="/api/documents/upload"
                listType="picture"
                onChange={({ fileList }) => setFiles1(fileList)}
                onPreview={handlePreview}
            >
                <Button icon={<UploadOutlined />}>
                Ajouter pièces jointes
                </Button>
            </Upload>

                

            </Form.Item>

            <Form.Item label="Pièces jointes 2">
            <Upload
                multiple
                maxCount={5}
                fileList={files2}
                action="/api/documents/upload"
                listType="text"
                onChange={({ fileList }) => setFiles2(fileList)}
                headers={{
                Authorization: "Bearer xxx" // si nécessaire
                }}
            >
                <Button icon={<UploadOutlined />}>
                Ajouter pièces jointes
                </Button>
            </Upload>
            </Form.Item>

            <Form.Item label="Pièces jointes 3">
            <Upload
                multiple
                maxCount={5}
                fileList={files3}
                action="/api/documents/upload"
                listType="text"
                onChange={({ fileList }) => setFiles3(fileList)}
                headers={{
                Authorization: "Bearer xxx" // si nécessaire
                }}
            >
                <Button icon={<UploadOutlined />}>
                Ajouter pièces jointes
                </Button>
            </Upload>
            </Form.Item>
            <Form.Item label="Pièces jointes 4">
            <Upload
                multiple
                maxCount={5}
                fileList={files4}
                action="/api/documents/upload"
                listType="text"
                onChange={({ fileList }) => setFiles4(fileList)}
                headers={{
                Authorization: "Bearer xxx" // si nécessaire
                }}
            >
                <Button icon={<UploadOutlined />}>
                Ajouter pièces jointes
                </Button>
            </Upload>
            </Form.Item>
            <Form.Item label="Pièces jointes 5">
            <Upload
                multiple
                maxCount={5}
                fileList={files5}
                action="/api/documents/upload"
                listType="text"
                onChange={({ fileList }) => setFiles5(fileList)}
                headers={{
                Authorization: "Bearer xxx" // si nécessaire
                }}
            >
                <Button icon={<UploadOutlined />}>
                Ajouter pièces jointes
                </Button>
            </Upload>
            </Form.Item>
            <Button type="primary" htmlType="submit">
              Enregistrer
            </Button>
 
          </Form>
        </Tabs.TabPane>
      </Tabs>

       <Modal
            open={previewVisible}
            footer={null}
            width={previewType === "pdf" ? 900 : 600}
            onCancel={() => setPreviewVisible(false)}
            >
            {previewType === "image" ? (
                <img
                alt="preview"
                style={{ width: "100%" }}
                src={previewUrl}
                />
            ) : (
                <iframe
                src={previewUrl}
                style={{ width: "100%", height: "80vh", border: "none" }}
                title="PDF Preview"
                />
            )}
        </Modal>

    </>
  );
}
